import dayjs from "dayjs"

const monthKey = (year, month) => year * 12 + month

export const withMonthRowFlags = (months = []) => {
  const now = dayjs()
  const current = monthKey(now.year(), now.month() + 1)

  return months.map((month, index) => {
    const key = monthKey(Number(month?.year), Number(month?.month))

    return {
      ...month,
      month_state: key === current ? "current" : key > current ? "future" : "past",
      is_last_month: index === months.length - 1
    }
  })
}
